module.exports = __webpack_public_path__ + "static/media/36-13.4f9fbade.mp3";